// src/utils/loadGoogleMaps.js
export function loadGoogleMaps(apiKey) {
  return new Promise((resolve, reject) => {
    if (typeof window.google === 'object' && typeof window.google.maps === 'object') {
      // Google Maps already loaded
      resolve(window.google);
      return;
    }

    const script = document.createElement('script');
    // script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap`;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap&libraries=places`;
    script.async = true;
    script.defer = true;

    window.initMap = () => {
      resolve(window.google);
      delete window.initMap; // Clean up
    };

    script.onerror = (error) => reject(error);

    document.head.appendChild(script);
  });
}


export async function getUserLocationX() {
  if (!("geolocation" in navigator)) {
    throw new Error("Geolocation is not available in this browser.");
  }

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        resolve({ latitude, longitude });
      },
      (error) => {
        console.log("Error obtaining location: " + error);
        console.log("return default location");

        reject(new Error("Error obtaining location: " + error.message));
      }
    );
  });
}


export async function getUserLocation() {
  if (!("geolocation" in navigator)) {
    console.log("Geolocation is not available in this browser. Returning default location.");
    return { latitude: 25.05, longitude: 121.525 }; // Default location
  }

  const options = {}

  const geoOptions = {
    enableHighAccuracy: true,
    timeout: 15000, // 5-second timeout for a quick response
    maximumAge: 6000000, // Use a cached position up to 1 minute old
    ...options, // Caller options override defaults
  };

  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        resolve({ latitude, longitude });
      },
      (error) => {
        console.log("Error obtaining location: " + error.message);
        console.log("Returning default location.");
        // Default fallback location
        const latitude = 25.05;
        const longitude = 121.525;
        resolve({ latitude, longitude });
      },
       geoOptions
    );
  });
}

export async function getUserLocationZ(options = {}) {
  if (!("geolocation" in navigator)) {
    throw new Error("Geolocation is not available in this browser.");
  }

  // Define default options, which can be overridden by the caller.
  // These defaults are set to quickly return a cached position.
  const geoOptions = {
    enableHighAccuracy: true,
    timeout: 15000, // 5-second timeout for a quick response
    maximumAge: 6000000, // Use a cached position up to 1 minute old
    ...options, // Caller options override defaults
  };

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        resolve({ latitude, longitude });
      },
      (error) => {
        let errorMessage = 'An unknown geolocation error occurred.';
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = 'User denied the request for Geolocation.';
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = 'Location information is unavailable.';
            break;
          case error.TIMEOUT:
            errorMessage = 'The request to get user location timed out.';
            break;
        }
        console.error(errorMessage, error);
        reject(new Error(errorMessage));
      },
      geoOptions
    );
  });
}


export async function navigateToParking() {
  const aaa = await getUserLocation();
  console.log("aaa", aaa);
  const src_lat = aaa.latitude;
  const src_lng = aaa.longitude;
  // const { latitude, longitude } = await getUserLocation();
  // const {src_lat, src_lng} = aaa;
  console.log("src_lat, src_lng", src_lat, src_lng);
  const { latitude, longitude } = this.parking;
  // const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
  const mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${src_lat},${src_lng}&destination=${latitude},${longitude}&travelmode=driving`;

  window.open(mapsUrl, '_blank'); // Open Google Maps in a new tab
}